
/*
    All of the routes and respective user access roles for the application
    organized in one place

    the route objects are as follows:

    const ALL_SUBROUTE = {
        name: "ALL_SUBROUTE",
        path: "/ops/all",
        label: "All",
        hasFilter: true,
        filterOpenByDefault: false,
        component: BusOpsAllPage
    };
*/


// the actual components to be displayed for the routes
// to be passed into React.createElement()

import BusOpsArrivalsPage from "./Containers/BusOpsArrivalsPage";
import BusOpsDepartedPage from "./Containers/BusOpsDepartedPage";
import BusOpsReassignedPage from "./Containers/BusOpsReassignedPage";
import BusOpsAllPage from "./Containers/BusOpsAllPage";
import LaneAssignmentsPage from "./Containers/LaneAssignmentsPage";
import LaneChangesPage from "./Containers/LaneChangesPage";
import MessagesGeneralPage from "./Containers/MessagesGeneralPage";
import MessagesSentPage from "./Containers/MessagesSentPage";
import MessagesLocationPage from "./Containers/MessagesLocationPage";
import MessagesTTSPage from "./Containers/MessagesTTSPage";
import ReportQuarterlyPage from "./Containers/ReportQuarterlyPage";
import ReportReassignmentPage from "./Containers/ReportReassignmentPage";
import ReportStarterPage from "./Containers/ReportStarterPage";
import ReportTripOnTimePage from "./Containers/ReportTripOnTimePage";
import UserManagementPage from "./Containers/UserManagementPage";
import TTS_Admin_Page from "./Containers/TTS_Admin_Page";
import BusMapPage from "./Containers/BusMapPage";
import LogPage from "./Containers/LogPage";

const BANNER_HEIGHT_VH = 10;

//
// BUS OPS
//

const ALL_SUBROUTE = {
    name: "ALL_SUBROUTE",
    path: "/ops/all",
    label: "All",
    hasFilter: true,
    filterOpenByDefault: false,
    component: BusOpsAllPage
};

const ARRIVALS_SUBROUTE = {
    name: "ARRIVALS_SUBROUTE",
    path: "/ops/arrivals",
    label: "Active Trips",
    hasFilter: true,
    filterOpenByDefault: false,
    component: BusOpsArrivalsPage
};

const DEPARTED_SUBROUTE = {
    name: "DEPARTED_SUBROUTE",
    path: "/ops/departed",
    label: "Departed Trips",
    hasFilter: true,
    filterOpenByDefault: false,
    component: BusOpsDepartedPage
};

const REASSIGNED_SUBROUTE = {
    name: "REASSIGNED_SUBROUTE",
    path: "/ops/reassigned",
    label: "Reassigned",
    hasFilter: true,
    filterOpenByDefault: false,
    component: BusOpsReassignedPage
};

const BUSOPS_ROUTE = {
    name: "BUSOPS_ROUTE",
    path: "/ops",
    label: "Ops",
    subpages: {
        ALL_SUBROUTE,
        ARRIVALS_SUBROUTE,
        DEPARTED_SUBROUTE,
        REASSIGNED_SUBROUTE
    },
    defaultSubpage: ALL_SUBROUTE,
    defaultComponent: BusOpsAllPage
};

const BUSOPS_ROUTE_STARTER = {
    name: "BUSOPS_ROUTE_STARTER",
    path: "/ops",
    label: "Ops",
    subpages: {
        ARRIVALS_SUBROUTE,
        DEPARTED_SUBROUTE,
        REASSIGNED_SUBROUTE
    },
    defaultSubpage: ARRIVALS_SUBROUTE,
    defaultComponent: BusOpsArrivalsPage
};

//
// MESSAGES
//

const GENERAL_SUBROUTE = {
    name: "GENERAL_SUBROUTE",
    path: "/messages/general",
    label: "General",
    hasFilter: true,
    filterOpenByDefault: false,
    component: MessagesGeneralPage
};

// const MANAGER_SUBROUTE = {
//     path: "/messages/manager",
//     label: "Management",
//     hasFilter: true,
//     filterOpenByDefault: false,
//     component: MessagesManagementPage
// };

const TTS_SUBROUTE = {
    name: "TTS_SUBROUTE",
    path: "/messages/tts",
    label: "TTS Deployment",
    hasFilter: false,
    filterOpenByDefault: false,
    component: MessagesTTSPage
};

const LOCATION_SUBROUTE = {
    name: "LOCATION_SUBROUTE",
    path: "/messages/location",
    label: "Location",
    hasFilter: false,
    filterOpenByDefault: false,
    component: MessagesLocationPage,
    busOnly: true
};

const SENT_SUBROUTE = {
    name: "SENT_SUBROUTE",
    path: "/messages/sent",
    label: "Sent Msgs",
    hasFilter: true,
    filterOpenByDefault: false,
    component: MessagesSentPage
};

const STARTER_MESSAGES_ROUTE = {
    name: "STARTER_MESSAGES_ROUTE",
    path: "/messages",
    label: "Messages",
    subpages: {
        SENT_SUBROUTE
    },
    defaultSubpage: SENT_SUBROUTE,
    defaultComponent: MessagesSentPage
}

const SUPERVISOR_MESSAGES_ROUTE = {
    name: "SUPERVISOR_MESSAGES_ROUTE",
    path: "/messages",
    label: "Messages",
    subpages: {
        GENERAL_SUBROUTE,
        LOCATION_SUBROUTE,
        SENT_SUBROUTE
    },
    defaultSubpage: GENERAL_SUBROUTE,
    defaultComponent: MessagesGeneralPage
}

const MESSAGES_ROUTE = {
    name: "MESSAGES_ROUTE",
    path: "/messages",
    label: "Messages",
    subpages: {
        GENERAL_SUBROUTE,
        // MANAGER_SUBROUTE,
        TTS_SUBROUTE,
        LOCATION_SUBROUTE,
        SENT_SUBROUTE
    },
    defaultSubpage: GENERAL_SUBROUTE,
    defaultComponent: MessagesGeneralPage
};

//
// LANE ASSIGNMENT
//

const LANEASSIGNMENT_ROUTE = {
    name: "LANEASSIGNMENT_ROUTE",
    path: "/laneassignment",
    label: "Lane Assignment",
    subpages: {},
    defaultSubpage: null,
    hasFilter: false,
    filterOpenByDefault: false,
    defaultComponent: LaneAssignmentsPage,
    busOnly: true
};

//
// LANE CHANGE
//

const LANECHANGE_ROUTE = {
    name: "LANECHANGE_ROUTE",
    path: "/lanechange",
    label: "Lane/Gate Change",
    subpages: {},
    defaultSubpage: null,
    hasFilter: true,
    filterOpenByDefault: false,
    defaultComponent: LaneChangesPage,
    busOnly: true
};

//
// USER MANAGEMENT
//

/*
const REGISTRATION_SUBROUTE = {
    path: "/user/registration",
    label: "Registration",
    hasFilter: false,
    filterOpenByDefault: false,
    component: UserRegistrationPage
};
*/

const MANAGEMENT_SUBROUTE = {
    name: "MANAGEMENT_SUBROUTE",
    path: "/user/management",
    label: "Management",
    hasFilter: false,
    filterOpenByDefault: false,
    component: UserManagementPage
};

const USERMANAGEMENT_ROUTE = {
    name: "USERMANAGEMENT_ROUTE",
    path: "/user",
    label: "User Management",
    subpages: {} /*{
        REGISTRATION_SUBROUTE,
        MANAGEMENT_SUBROUTE
    }*/,
    defaultSubpage: null, // REGISTRATION_SUBROUTE,
    hasFilter: true,
    filterOpenByDefault: true,
    defaultComponent: UserManagementPage
};

//
// REPORTS
//

const STARTER_SUBROUTE = {
    name: "STARTER_SUBROUTE",
    path: "/reports/starter",
    label: "Starter Sheet",
    hasFilter: true,
    filterOpenByDefault: true,
    component: ReportStarterPage
};

const TRIPONTIME_SUBROUTE = {
    name: "TRIPONTIME_SUBROUTE",
    path: "/reports/tripontime",
    label: "Trip on Time",
    hasFilter: true,
    filterOpenByDefault: true,
    component: ReportTripOnTimePage
};

const QUARTERLY_SUBROUTE = {
    name: "QUARTERLY_SUBROUTE",
    path: "/reports/quarterly",
    label: "Quarterly",
    hasFilter: true,
    filterOpenByDefault: true,
    component: ReportQuarterlyPage
};

const REASSIGNMENT_SUBROUTE = {
    name: "REASSIGNMENT_SUBROUTE",
    path: "/reports/reassignment",
    label: "Reassignment",
    hasFilter: true,
    filterOpenByDefault: true,
    component: ReportReassignmentPage
};

const REPORTS_ROUTE = {
    name: "REPORTS_ROUTE",
    path: "/reports",
    label: "Reports",
    subpages: {
        STARTER_SUBROUTE,
        TRIPONTIME_SUBROUTE,
        QUARTERLY_SUBROUTE,
        REASSIGNMENT_SUBROUTE
    },
    defaultSubpage: STARTER_SUBROUTE,
    defaultComponent: ReportStarterPage
};

//
//
//

const TTS_ADMIN_ROUTE = {
    name: "TTS_ADMIN_ROUTE",
    path: "/ttsadmin",
    label: "TTS Admin",
    subpages: {},
    defaultSubpage: null,
    defaultComponent: TTS_Admin_Page
}

//
//
//

const MAP_ROUTE = {
    name: "MAP_ROUTE",
    path: "/map",
    label: "BUS MAP",
    hasFilter: true,
    subpages: {},
    defaultSubpage: null,
    defaultComponent: BusMapPage,
    busOnly: true
}

//
//
//

const LOGS_ROUTE = {
    name: "LOGS_ROUTE",
    path: "/logs",
    label: "LOGS",
    hasFilter: true,
    subpages: {},
    defaultSubpage: null,
    filterOpenByDefault: true,
    defaultComponent: LogPage
}

/*
*
*
*
put it all together for easy consumption when imported
*
*
*/

const CONSTANTS = {
    BANNER_HEIGHT_VH,
    routes: {
        BUSOPS_ROUTE,
        BUSOPS_ROUTE_STARTER,
        MESSAGES_ROUTE,
        LANEASSIGNMENT_ROUTE,
        LANECHANGE_ROUTE,
        REPORTS_ROUTE,
        USERMANAGEMENT_ROUTE,
        TTS_ADMIN_ROUTE,
        MAP_ROUTE
    },
    access: {
        admin: {
            routes: [
                BUSOPS_ROUTE,
                MESSAGES_ROUTE,
                LANEASSIGNMENT_ROUTE,
                LANECHANGE_ROUTE,
                REPORTS_ROUTE,
                USERMANAGEMENT_ROUTE,
                TTS_ADMIN_ROUTE,
                MAP_ROUTE,
                LOGS_ROUTE
            ],
            defaultRoute: BUSOPS_ROUTE
        },
        supervisor: {
            routes: [
                BUSOPS_ROUTE,
                SUPERVISOR_MESSAGES_ROUTE,
                LANECHANGE_ROUTE,
                REPORTS_ROUTE,
                MAP_ROUTE        
            ],
            defaultRoute: BUSOPS_ROUTE
        },
        starter: {
            routes: [
                BUSOPS_ROUTE_STARTER,
                STARTER_MESSAGES_ROUTE,
                MAP_ROUTE
            ],
            defaultRoute: BUSOPS_ROUTE_STARTER
        },
        report: {
            routes: [
                REPORTS_ROUTE
            ],
            defaultRoute: REPORTS_ROUTE
        },
        operator: {
            routes: [
                BUSOPS_ROUTE,
                SUPERVISOR_MESSAGES_ROUTE,
                LANECHANGE_ROUTE,
                REPORTS_ROUTE,
                MAP_ROUTE         
            ],
            defaultRoute: BUSOPS_ROUTE
        }
    }
};

export default CONSTANTS;

//
// this lookup is useful for reloading the user's previous location when they return after closing their browser
//
export const Lookup = {
    ALL_SUBROUTE,
    ARRIVALS_SUBROUTE,
    DEPARTED_SUBROUTE,
    BUSOPS_ROUTE,
    BUSOPS_ROUTE_STARTER,
    GENERAL_SUBROUTE,
    TTS_SUBROUTE,
    LOCATION_SUBROUTE,
    SUPERVISOR_MESSAGES_ROUTE,
    MESSAGES_ROUTE,
    LANEASSIGNMENT_ROUTE,
    LANECHANGE_ROUTE,
    MANAGEMENT_SUBROUTE, 
    USERMANAGEMENT_ROUTE,
    STARTER_SUBROUTE,
    TRIPONTIME_SUBROUTE,
    QUARTERLY_SUBROUTE,
    REASSIGNMENT_SUBROUTE,
    REPORTS_ROUTE,
    TTS_ADMIN_ROUTE,
    MAP_ROUTE,
    LOGS_ROUTE
};